const getStatus = (request) => {
    if (!request)
        return "new";
    if (request.data.status === 'withdrawn')
        return "withdrawn";
    if (request.data.status === 'unsuccessful')
        return "unsuccessful";
    if (request.data.status === 'matched')
        return "matched - donation pending";
    if (request.data.status === 'completed')
        return "matched - donation completed";
    if (request.data.status === 'failed')
        return "matched - donation abandoned";
    if (request.data.status === 'selected')
        return "match pending";
    if (request.data.status === 'interested')
        return "interest expressed";
    return "requested";
};
export default getStatus;
